import Axios from 'axios'
import { activityUrls } from '../urls'
import router from '../../../router'

export default {
  post_availability_schedule (context, data) {
    Axios.post(activityUrls.postActivitySchedule, data).then(() => {
      context.dispatch('get_availability_schedule', data.inventory_id)
      router.push({
        name: 'SingleInventory',
        params: {
          inventory_id: data.inventory_id
        }
      })
    })
  },
  edit_availability_schedule (context, data) {
    Axios.patch(activityUrls.modifyActivitySchedule, data).then(function (response) {
      context.dispatch('get_availability_schedule', data.inventory_id)
    })
  },
  post_activity_surge_schedule (context, data) {
    Axios.post(activityUrls.postActivitySurgeSchedule, data).then(() => {
      context.dispatch('get_activity_surge_schedule', data.inventory_id)
      router.push({
        name: 'SingleInventory',
        params: {
          inventory_id: data.inventory_id
        }
      })
    })
  },
  get_availability_schedule (context, publicId) {
    Axios.get(activityUrls.getActivitySchedule + publicId).then((response) => {
      context.commit('AVAILABILITY_SCHEDULE', response.data)
    })
  },
  get_activity_surge_schedule (context, publicId) {
    Axios.get(activityUrls.getActivitySchedule + publicId).then((response) => {
      context.commit('SURGE_SCHEDULE', response.data)
    })
  },
  delete_availability_schedule (context, data) {
    Axios.patch(activityUrls.deleteActivitySchedule, data).then((response) => {
      context.commit('AVAILABILITY_SCHEDULE', response.data)
      context.dispatch('get_availability_schedule', data.inventory_id)
      router.push({
        name: 'SingleInventory',
        params: {
          inventory_id: data.inventory_id
        }
      })
    })
  },
  get_all_activities (context) {
    Axios.get(activityUrls.getAllActivities).then(function (response) {
      context.commit('GET_ALL_ACTIVITIES', response.data)
    })
  },
  get_public_active_activities (context) {
    Axios.get(activityUrls.getActiveActivities).then(function (response) {
      context.commit('GET_ACTIVE_ACTIVITIES', response.data)
    })
  },
  get_active_activities (context) {
    Axios.get(activityUrls.getActiveActivities).then(function (response) {
      context.commit('GET_ACTIVE_ACTIVITIES', response.data)
    })
  },
  get_in_active_activities (context) {
    Axios.get(activityUrls.getInActiveActivities).then(function (response) {
      context.commit('GET_IN_ACTIVE_ACTIVITIES', response.data)
    })
  },
  check_single_inventory_availability (context, publicId) {
    Axios.get(activityUrls.getActivityAvailability + publicId).then((response) => {
      context.commit('GET_SINGLE_AVAILABILITY')
    })
  },
  get_activity_images (context, publicId) {
    Axios.get(activityUrls.getActivityImages + publicId).then(function (response) {
      context.commit('GET_ACTIVITY_IMAGES', response.data)
    }).catch(function () {
      context.commit('GET_ACTIVITY_IMAGES', [])
    })
  },
  delete_activity_image (context, data) {
    Axios.get(activityUrls.deleteActivityImage + data.public_id).then(function (response) {
      context.dispatch('get_activity_images', data.inventory_id)
    })
  },
  delete_thumbnail_activity_image (context, publicId) {
    Axios.post(activityUrls.deleteThumbnailActivityImage + publicId).then(function (response) {
      context.dispatch('get_activity_images', publicId)
    })
  },
  make_activity_inactive (context, data) {
    Axios.post(activityUrls.makeActivityInactive, data).then(function () {
      context.dispatch('get_all_activities')
      router.push({
        name: data.redirect_url
      })
    }).catch(function (error) {
      // console.log(error.data)
    })
  },
  make_activity_active (context, data) {
    Axios.post(activityUrls.makeActivityActive, data).then(function () {
      context.dispatch('get_all_activities')
      router.push({
        name: data.redirect_url
      })
    }).catch(function (error) {
      // console.log(error.data)
    })
  },
  get_activities (context, publicId) {
    Axios.get(activityUrls.getActivitys + publicId).then(function (response) {
      context.commit('GET_ACTIVITIES', response.data)
    })
  },
  get_deleted_activities (context) {
    Axios.get(activityUrls.getDeletedActivity).then(function (response) {
      context.commit('GET_DELETED_ACTIVITIES', response.data)
    })
  },
  get_activity (context, publicId) {
    context.commit('GET_ACTIVITY', { data: [{}] })
    Axios.get(activityUrls.getActivity + publicId).then(function (response) {
      context.commit('GET_ACTIVITY', response.data)
    })
  },
  get_activity_with_pricing (context, data) {
    context.commit('GET_ACTIVITY_PRICE_AT_DATE', { data: [{}] })
    Axios.post(activityUrls.getActivityPriceAtDate + data.public_id, data).then(function (response) {
      context.commit('GET_ACTIVITY_PRICE_AT_DATE', response.data)
     
    })
  },
  post_activity (context, data) {
    Axios.post(activityUrls.postActivity, data).then(function () {
      context.dispatch('get_all_activities')
      router.push({
        name: 'Inventory'
      })
    }).catch(function (error) {
      context.commit('UPDATE_ERRORS', error.data)

    })
  },
  update_activity (context, data) {
    Axios.post(activityUrls.editActivity + data.public_id, data).then(function () {
      context.dispatch('get_all_activities')
      router.push({
        name: 'Inventory',
        params: {
          inventory_id: data.public_id
        }
      })
    }).catch(function (error) {
      // console.log(error.data)
    })
  },
  delete_activity (context, data) {
    Axios.post(activityUrls.deleteActivity + data.inventory_id, data).then(function () {
      router.push({
        name: 'Inventory'
      })
    })
  },
  restoreActivity (context, publicId) {
    Axios.get(activityUrls.restoreActivity + publicId).then(function (response) {
      alert(response.data.message)
      context.commit('GET_ALL_ACTIVITIES', response.data)
      router.push({
        name: 'Module.Activitys'
      })
    })
  }
}
